const resource = `mediaAssignments`;

export default $axios => ({
    getVenueMedia(venueId) {
        return $axios.get(`/${resource}/venue/${venueId}`);
    },
    assignVenueMedia(typeId, mediaData) {
        return $axios.post(`/${resource}/venue/${typeId}`, {
            media_id: mediaData.id,
            location: mediaData.location,
        });
    },
    updateVenueMedia(typeId, assignmentId, mediaData) {
        return $axios.put(`/${resource}/venue/${typeId}/${assignmentId}`, {
            media_id: mediaData.id,
            location: mediaData.location,
        });
    },
    deleteVenueMedia(typeId, id) {
        return $axios.delete(`/${resource}/venue/${typeId}/${id}`);
    },

    getProductMedia(venueId) {
        return $axios.get(`/${resource}/product/${venueId}`);
    },
    assignProductMedia(typeId, mediaData) {
        return $axios.post(`/${resource}/product/${typeId}`, {
            media_id: mediaData.id,
            location: mediaData.location,
        });
    },
    updateProductMedia(typeId, assignmentId, mediaData) {
        return $axios.put(`/${resource}/product/${typeId}/${assignmentId}`, {
            media_id: mediaData.id,
            location: mediaData.location,
        });
    },
    deleteProductMedia(typeId, id) {
        return $axios.delete(`/${resource}/product/${typeId}/${id}`);
    },
});
